import { createBrowserHistory } from "history";

export const history = createBrowserHistory({});

export function navigateTo(path) {
  history.push(path);
}

export function redirectTo(path) {
  history.replace(path);
}

export function goBack() {
  history.back();
}
